import { render, staticRenderFns } from "./userMana.vue?vue&type=template&id=0f9fa2fd&scoped=true&"
import script from "./userMana.vue?vue&type=script&lang=js&"
export * from "./userMana.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9fa2fd",
  null
  
)

export default component.exports